import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  CloseButton,
  Form,
  InputGroup,
  Table,
} from "@themesberg/react-bootstrap";
import React, { useEffect, useState, Component } from "react";
import {useHistory, Link } from "react-router-dom";
import ProfileImg from "../assets/img/profile-cover.jpg";
import { Routes } from "../routes";
import { FormattedMessage } from "react-intl";
import { UserEditForm, CreateUserForm, CompanyInfoForm } from "./Forms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
} from "@fortawesome/free-solid-svg-icons";

export const ExeclUploadSuccess = ({ disabled }) => {

  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>기다리는 중!</p>
        <p>이 작업은 시간이 오래걸립니다.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          disabled={disabled}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const UpdateSuccess = ({ disabled }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>기다리는 중!</p>
        <p>이 작업은 시간이 오래걸립니다.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          disabled={disabled}
        >
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const CreateSuccessModal = ({ id }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id={id} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const HomeDisplayItem = ({ item }) => {
  return (
    <Card style={{ width: "20rem" }} className="mx-2">
      <Card.Img variant="top" src={ProfileImg} />
      <Card.Body>
        <Card.Title>{item._source.Name}</Card.Title>
        <Card.Text>
          Some quick example text to build on the card title and make up the
          bulk of the card's content.
        </Card.Text>
        <Button
          variant="primary"
          href={
            Routes.CompInfo.path + "?index=" + item._index + "&id=" + item._id
          }
        >
          Go somewhere
        </Button>
      </Card.Body>
    </Card>
  );
};

export const SignUpSuccess = ({ email }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h6">
          <FormattedMessage id="verifiedEmail" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>{email}</strong> <FormattedMessage id="sendEmail" />
          <br />
          <FormattedMessage id="openEmail" />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button href={Routes.Signin.path} variant="secondary">
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const ReqCancelModal = ({ disabled }) => {
  return (
    <Modal as={Modal.Dialog} show centered>
      <Modal.Header>
        <Modal.Title className="h5">
          매칭 취소 결과
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>기다리는 중!</p>
        <p>이 작업은 시간이 오래걸립니다.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          disabled={disabled}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const SignUpModal = ({ disabled,body }) => {
  return (
    <Modal as={Modal.Dialog} show centered>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="signupResults" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{body}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          disabled={disabled}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const AdminModal = () => {
  return (
    <Modal as={Modal.Dialog} show centered>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>관리자만 접근 가능합니다.</p>
      </Modal.Body>
    </Modal>
  );
};

export const UserEditModal = ({ user, onCancel }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="toEdit" />
        </Modal.Title>
        <CloseButton onClick={onCancel} />
      </Modal.Header>
      <Modal.Body>
        <UserEditForm user={user} />
      </Modal.Body>
    </Modal>
  );
};

export const MatCancelErrorModal = ({ onCancel }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
        <CloseButton onClick={onCancel} />
      </Modal.Header>
      <Modal.Body>
        요청한 매칭이 없습니다.
      </Modal.Body>
    </Modal>
  );
};

export const DeleteSuccessModal = () => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>해당 사용자가 삭제되었습니다.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
        >
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const CreateUserModal = ({ onCancel }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="toCreate" />
        </Modal.Title>
        <CloseButton onClick={onCancel} />
      </Modal.Header>
      <Modal.Body>
        <CreateUserForm />
      </Modal.Body>
    </Modal>
  );
};

export const CompanyEditModal = ({ comp, onCancel }) => {
  const [input, setInput] = useState({
    ...comp,
  });

  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
        <CloseButton onClick={onCancel} />
      </Modal.Header>
      <Modal.Body>
        <CompanyInfoForm company={input} setCompany={setInput} />
      </Modal.Body>
    </Modal>
  );
};

export const CompanyDeleteModal = ({ id }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id={id || "msg error"} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const CompCreateSuccessModal = () => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="success" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id="compCreateSuccess" />
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const CompanyCreateModal = ({ onCancel }) => {
  const [input, setInput] = useState({
    id: "",
    Name: "",
    RegistrationID: "",
    worker_num: "",
    revenue: "",
    Phone: "",
    EmailAddress: "",
    Website: "",
    NameInRussian: "",
    PrincipalName: "",
    industry: "",
    establish: "",
    LegalAddress: "",
    country: "",
  });

  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
        <CloseButton onClick={onCancel} />
      </Modal.Header>
      <Modal.Body>
        <CompanyInfoForm company={input} setCompany={setInput} handle={true} />
      </Modal.Body>
    </Modal>
  );
};

export const Load = ({ disabled, id }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>기다리는 중!</p>
        <p>이 작업은 시간이 오래걸립니다.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          disabled={disabled}
        >
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const SurveyModal = ({ onCancel }) => {
  const [input, setInput] = useState({
    responseCompanyNm: "",
    matchingCompanyNm: "",
    respondentNm: "",
    respondentContract: "",
    respondentEmail: "",
    question1: "",
    question2: "",
    question3: "",
    question4: "",
    question5: "",
    question6: "",
  });

  const [msg, setMsg] = useState({
    responseCompanyNmMsg: "",
    matchingCompanyNmMsg: "",
    respondentNmMsg: "",
    respondentContractMsg: "",
    respondentEmailMsg: "",
    question6Msg: "",
  });

  const {
    responseCompanyNm,
    matchingCompanyNm,
    respondentNm,
    respondentContract,
    respondentEmail,
    question1,
    question2,
    question3,
    question4,
    question5,
    question6,
  } = input;
  const {
    responseCompanyNmMsg,
    matchingCompanyNmMsg,
    respondentNmMsg,
    respondentContractMsg,
    respondentEmailMsg,
    question6Msg,
  } = msg;

  const onSubmit = (e) => {
    e.preventDefault();

    fetch("api/survay", {
      method: "post",
      body: JSON.stringify({
        responseCompanyNm,
        matchingCompanyNm,
        respondentNm,
        respondentContract,
        respondentEmail,
        question1,
        question2,
        question3,
        question4,
        question5,
        question6,
      }),
    }).then((resp) => {
      if (resp.status === 200) {
      }
    });
  };

  const onChange = (e) => {
    const { name, value } = e.target;

    if (name === "question1" && value === "1") {
      setInput((prev) => ({ ...prev, question1: 1 }));
    }
    else if (name === "question1" && value === "2") {
      setInput((prev) => ({ ...prev, question1: 2 }));
    }
    else if (name === "question1" && value === "3") {
      setInput((prev) => ({ ...prev, question1: 3 }));
    }
    else if (name === "question1" && value === "4") {
      setInput((prev) => ({ ...prev, question1: 4 }));
    }
    else if (name === "question1" && value === "5") {
      setInput((prev) => ({ ...prev, question1: 5 }));
    }
    else if (name === "question2" && value === "1") {
      setInput((prev) => ({ ...prev, question2: 1 }));
    }
    else if (name === "question2" && value === "2") {
      setInput((prev) => ({ ...prev, question2: 2 }));
    }
    else if (name === "question2" && value === "3") {
      setInput((prev) => ({ ...prev, question2: 3 }));
    }
    else if (name === "question2" && value === "4") {
      setInput((prev) => ({ ...prev, question2: 4 }));
    }
    else if (name === "question2" && value === "5") {
      setInput((prev) => ({ ...prev, question2: 5 }));
    }
    else if (name === "question3" && value === "1") {
      setInput((prev) => ({ ...prev, question3: 1 }));
    }
    else if (name === "question3" && value === "2") {
      setInput((prev) => ({ ...prev, question3: 2 }));
    }
    else if (name === "question3" && value === "3") {
      setInput((prev) => ({ ...prev, question3: 3 }));
    }
    else if (name === "question3" && value === "4") {
      setInput((prev) => ({ ...prev, question3: 4 }));
    }
    else if (name === "question3" && value === "5") {
      setInput((prev) => ({ ...prev, question3: 5 }));
    }
    else if (name === "question4" && value === "1") {
      setInput((prev) => ({ ...prev, question4: 1 }));
    }
    else if (name === "question4" && value === "2") {
      setInput((prev) => ({ ...prev, question4: 2 }));
    }
    else if (name === "question4" && value === "3") {
      setInput((prev) => ({ ...prev, question4: 3 }));
    }
    else if (name === "question4" && value === "4") {
      setInput((prev) => ({ ...prev, question4: 4 }));
    }
    else if (name === "question4" && value === "5") {
      setInput((prev) => ({ ...prev, question4: 5 }));
    }
    else if (name === "question5" && value === "1") {
      setInput((prev) => ({ ...prev, question5: 1 }));
    }
    else if (name === "question5" && value === "2") {
      setInput((prev) => ({ ...prev, question5: 2 }));
    }
    else if (name === "question5" && value === "3") {
      setInput((prev) => ({ ...prev, question5: 3 }));
    }
    else if (name === "question5" && value === "4") {
      setInput((prev) => ({ ...prev, question5: 4 }));
    }
    else if (name === "question5" && value === "5") {
      setInput((prev) => ({ ...prev, question5: 5 }));
    }
    else
    {
      setInput((prev) => ({ ...prev, [name]: value }));
    }

    
  };

  return (
    <Modal as={Modal.Dialog} size="lg" show centered>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="survayTitle" />
          <CloseButton onClick={onCancel} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="mt-4">
          <Form.Group id="responseCompanyNm" className="mb-4">
            <Form.Label>
              <FormattedMessage id="survayResponseCompanyNm" />
            </Form.Label>
            <InputGroup>
              <Form.Control
                autoFocus
                required
                type="text"
                name="responseCompanyNm"
                value={responseCompanyNm}
                onChange={onChange}
              />
            </InputGroup>
            {responseCompanyNmMsg && <p className="text-danger">{responseCompanyNmMsg}</p>}
          </Form.Group>
          <Form.Group id="matchingCompanyNm" className="mb-4">
            <Form.Label>
              <FormattedMessage id="survayMatchingCompanyNm" />
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                type="text"
                name="matchingCompanyNm"
                value={matchingCompanyNm}
                onChange={onChange}
              />
            </InputGroup>
            {matchingCompanyNmMsg && <p className="text-danger">{matchingCompanyNmMsg}</p>}
          </Form.Group>
          <Form.Group id="respondentNm" className="mb-4">
            <Form.Label>
              <FormattedMessage id="survayRespondentNm" />
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                type="text"
                name="respondentNm"
                value={respondentNm}
                onChange={onChange}
              />
            </InputGroup>
            {respondentNmMsg && <p className="text-danger">{respondentNmMsg}</p>}
          </Form.Group>
          <Form.Group id="respondentContract" className="mb-4">
            <Form.Label>
              <FormattedMessage id="survayRespondentContract" />
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                type="phone"
                name="respondentContract"
                value={respondentContract}
                onChange={onChange}
              />
            </InputGroup>
            {respondentContractMsg && <p className="text-danger">{respondentContractMsg}</p>}
          </Form.Group>
          <Form.Group id="respondentEmail" className="mb-4">
            <Form.Label>
              <FormattedMessage id="survayRespondentEmail" />
            </Form.Label>
            <InputGroup>
              <Form.Control
                required
                type="email"
                name="respondentEmail"
                value={respondentEmail}
                onChange={onChange}
              />
            </InputGroup>
            {respondentEmailMsg && <p className="text-danger">{respondentEmailMsg}</p>}
          </Form.Group>
        </Form>
        <Form >
          <Table>
            <thead>
              <tr>
                <td><FormattedMessage id="survayContent" /></td>
                <td><FormattedMessage id="survayVeryGood_1" /><br/><FormattedMessage id="survayVeryGood_2" /></td>
                <td><FormattedMessage id="survayGood_1" /><br/><FormattedMessage id="survayGood_2" /></td>
                <td><FormattedMessage id="survayCommon" /></td>
                <td><FormattedMessage id="survayDissatisfaction_1" /><br/><FormattedMessage id="survayDissatisfaction_2" /></td>
                <td><FormattedMessage id="survayVeryDissatisfaction_1" /><br/><FormattedMessage id="survayVeryDissatisfaction_2" /></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <FormattedMessage id="survayQuection1_1" /><br/>
                  <FormattedMessage id="survayQuection1_2" />
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question1"
                      value="1"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question1"
                      value="2"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question1"
                      value="3"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question1"
                      value="4"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question1"
                      value="5"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <FormattedMessage id="survayQuection2_1" /><br/>
                  <FormattedMessage id="survayQuection2_2" />
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question2"
                      value="1"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question2"
                      value="2"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question2"
                      value="3"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question2"
                      value="4"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question2"
                      value="5"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <FormattedMessage id="survayQuection3_1" /><br/>
                  <FormattedMessage id="survayQuection3_2" />
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question3"
                      value="1"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question3"
                      value="2"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question3"
                      value="3"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question3"
                      value="4"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question3"
                      value="5"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
              </tr>
            </tbody>
          </Table>
        </Form>
        <Form >
          <Table>
            <thead>
              <tr>
                <td></td>
                <td><FormattedMessage id="survayVeryMuch_1" /><br/><FormattedMessage id="survayVeryMuch_2" /></td>
                <td><FormattedMessage id="survayMuch" /></td>
                <td><FormattedMessage id="survayNormal" /></td>
                <td><FormattedMessage id="survayLittle" /></td>
                <td><FormattedMessage id="survayVeryLittle_1" /><br/><FormattedMessage id="survayVeryLittle_2" /></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <FormattedMessage id="survayQuection4_1" /><br/>
                  <FormattedMessage id="survayQuection4_2" />
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question4"
                      value="1"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question4"
                      value="2"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question4"
                      value="3"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question4"
                      value="4"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question4"
                      value="5"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <FormattedMessage id="survayQuection5" />
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question5"
                      value="1"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question5"
                      value="2"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question5"
                      value="3"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question5"
                      value="4"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Radio
                      name="question5"
                      value="5"
                      onChange={onChange}
                    />
                  </InputGroup>
                </td>
              </tr>
            </tbody>
          </Table>
        </Form>
        <Form className="mt-4">
          <Form.Group id="question6" className="mb-4">
            <Form.Label>
              <FormattedMessage id="survayQuection6" />
            </Form.Label>
            <InputGroup>
              <Form.Control
                autoFocus
                required
                type="text"
                name="question6"
                value={question6}
                onChange={onChange}
              />
            </InputGroup>
            {question6Msg && <p className="text-danger">{question6Msg}</p>}
          </Form.Group>
        </Form>
        <Button
          variant="primary"
          type="submit"
          className="w-100"
          onClick={onSubmit}
        >
          <FormattedMessage id="survayConfirm" />
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export const MatProccessModal = ({ disabled, id, onCancel }) => {
  console.log(disabled);
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
        {onCancel && <CloseButton onClick={onCancel} />}
      </Modal.Header>
      <Modal.Body>
        {id ? (
          <FormattedMessage id={id} />
        ) : (
          <>
            <p>요청을 처리하고 있습니다...</p>
            <p>잠시만 기다려주세요!</p>
            <p>요청이 완료되면 아래의 버튼이 활성화 됩니다.</p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          disabled={disabled}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const MatNotAllowed = ({ onCancel, id }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h5">
          <FormattedMessage id="lookupResults" />
        </Modal.Title>
        <CloseButton onClick={onCancel} />
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id={id || "msgError"} />
      </Modal.Body>
    </Modal>
  );
};

class ResultModal extends Component {
  render() {
    const { isOpen, close, searchData } = this.props; //아까 버튼에서 props로 가져온것

    console.log(isOpen);

    return (
      <>
        {isOpen ? (
          ////만약 isopen(this.state.isModalOpen)이 true일때 코드를 실행 false면  null
          /// <div onClick={close}> 로그인창 말고 회색 바탕을 누를시 모달이 꺼지게 만듬
          ///<span className="close" onClick={close}>&times;</span> x버튼 누를시 꺼짐
          ////<div className="modalContents" onClick={isOpen}> 로그인 화면은 버튼 클릭해서 들어오면
          /// true인 상태로 있어서 화면이 안꺼진다.

          <div className="modal">
            <div onClick={close}>
              <div className="loginModal">
                <span className="close" onClick={close}>
                  &times;
                </span>
                <div className="modalContents" onClick={isOpen}>
                  <Container fluid className="my-2">
                    <Row
                      xs={1}
                      md={2}
                      lg={4}
                      className="g-4 justify-content-center"
                    >
                      {searchData.length &&
                        searchData.map((item) => (
                          <HomeDisplayItem item={item} key={item._index} />
                        ))}
                    </Row>
                  </Container>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default ResultModal;
